import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { projectsData, projectStats } from '../data';

const Projects = () => {
  const [ref, isVisible] = useScrollAnimation();
  const projects = projectsData || [];
  const stats = projectStats || [];

  return (
    <section className="section-padding" ref={ref}>
      <div className="container-custom">
        <div className="text-center mb-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <span className="section-badge">Our Portfolio</span>
            <h2 className="heading-primary mt-4">
              Featured <span className="text-gradient">Projects</span>
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto mt-4">
              From civil works and MEP systems to cleaning and industrial developments, 
              we execute every project with innovation, safety, and professionalism.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <motion.div
              key={project.id || index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={isVisible ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group bg-white rounded-2xl overflow-hidden shadow-soft card-hover"
            >
              <div className="relative overflow-hidden h-64">
                <img 
                  src={project.image || 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80'} 
                  alt={project.title || 'Project'}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute top-4 right-4">
                  <span className="px-3 py-1 bg-primary/90 text-white text-xs rounded-full font-medium">
                    {project.category || 'Project'}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-secondary font-oswald mb-2">
                  {project.title || 'Project Title'}
                </h3>
                <p className="text-gray-600 text-sm">
                  {project.description || 'Project description goes here.'}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Stats */}
        {stats.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-12"
          >
            {stats.map((stat) => (
              <div key={stat.id} className="bg-white rounded-2xl p-4 text-center shadow-soft">
                <div className="text-2xl md:text-3xl font-bold text-primary font-oswald">
                  {stat.number || '0'}
                </div>
                <div className="text-xs text-gray-500 mt-1">{stat.label || 'Stat'}</div>
              </div>
            ))}
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default Projects;